import { Tag } from "@dmm-com/rocket-web-ui-library";
import { memo } from "react";
import * as Styled from "./style";
import type { G_VideoCampaign, Maybe } from "~/lib/graphql";

type PurchaseCampaignProps = {
  campaign: Maybe<Pick<G_VideoCampaign, "endAt" | "name">> | undefined;
};

/**
 * 購入モーダルでキャンペーン情報を表示するコンポーネント
 * - キャンペーンが存在する場合 : キャンペーン名と終了日を表示させる
 */
export const PurchaseCampaign = memo((props: PurchaseCampaignProps) => {
  const { campaign } = props;

  if (campaign === undefined || campaign === null) return null;
  if (new Date(campaign.endAt).getTime() < Date.now()) return null;

  return (
    <Styled.DivCampaignBanner>
      <Tag tagText="セール" subText={campaign.name} bgColor="RED900" subTextColor="RED900" />
    </Styled.DivCampaignBanner>
  );
});

PurchaseCampaign.displayName = "PurchaseCampaign";
